(function () {
  const page = document.querySelector('.product-page');
  if (!page) return;
  const select = page.querySelector('[data-variant-select]');
  if (!select) return;

  const optionGroups = page.querySelectorAll('[data-option-index]');
  const colourGroup = page.querySelector('.colour-swatches');
  const colourIdx = colourGroup ? Number(colourGroup.dataset.optionIndex) : -1;

  function readChosenOptions() {
    return Array.from(optionGroups).map((g) => {
      const selectedBtn = g.querySelector('.selected, .active');
      return selectedBtn?.dataset.optionValue || null;
    });
  }

  function syncVariant() {
    const chosen = readChosenOptions();
    let match = null;
    select.querySelectorAll('option').forEach((opt) => {
      const opts = (opt.dataset.options || '').split(',');
      if (opts.length === chosen.length && opts.every((v, i) => v === chosen[i])) match = opt;
    });
    if (!match) return;
    select.value = match.value;
    const priceEl = page.querySelector('[data-price]');
    if (priceEl) priceEl.textContent = match.dataset.price;

    const colourNameEl = page.querySelector('[data-colour-name]');
    if (colourNameEl && colourIdx >= 0) colourNameEl.textContent = '— ' + chosen[colourIdx];

    const addBtn = page.querySelector('.btn-add-full');
    if (addBtn) {
      addBtn.disabled = match.disabled;
      addBtn.textContent = match.disabled ? 'Sold Out' : 'Add to Cart';
    }

    // Notify other listeners (e.g. add-to-cart form) that variant changed
    select.dispatchEvent(new Event('change', { bubbles: true }));
  }

  optionGroups.forEach((group) => {
    group.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-option-value]');
      if (!btn || btn.classList.contains('sold-out')) return;
      group.querySelectorAll('[data-option-value]').forEach((b) => b.classList.remove('selected', 'active'));
      btn.classList.add(group.classList.contains('colour-swatches') ? 'active' : 'selected');
      syncVariant();
    });
  });

  syncVariant();
})();
